import { useauthMeQuery } from '@/types/generated/graphql';
import { cacheOnly } from '@shared/constants';
import { useNavigate } from 'react-router-dom';
import { useSetupMfaReminder } from '../../../../../../../modules/auth/mfa/hooks/use-setup-mfa-reminder';
import dayjs from 'dayjs';
import { useLoginMethod } from '@shared/hooks/use-login-method';
import { useDesignVersion } from '@shared/hooks/use-design-version';

export const useMfaReminderBanner = () => {
  const navigate = useNavigate();
  const authMeResult = useauthMeQuery(cacheOnly);
  const user = authMeResult?.data?.authMe?.data?.user;
  const mfaTotpEnabled = user?.mfaTotpEnabled;
  const mfaEmailEnabled = user?.mfaEmailEnabled;
  const mfaReminderAt = user?.mfaReminderAt;
  const { isPasswordLogin } = useLoginMethod();
  const { isPermanentlyMigrated } = useDesignVersion();

  const { setMfaReminder, loading } = useSetupMfaReminder();

  function showMfaReminder() {
    if (!isPermanentlyMigrated) return false; // Only show MFA for permanently migrated users
    if (!isPasswordLogin) return false; // Only show MFA reminder for password login users
    if (mfaTotpEnabled || mfaEmailEnabled) return false;
    if (mfaReminderAt === null) return true;
    return dayjs(mfaReminderAt)?.isBefore(dayjs());
  }

  const handleLater = () => {
    setMfaReminder();
  };

  const handleSetupMFa = () => {
    navigate('/settings/my-profile/mfa');
  };

  return {
    loading,
    handleLater,
    handleSetupMFa,
    showMfaReminder,
  };
};
